import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "34",
  height: "42",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#FDD522",
  stroke: "#fff",
  "stroke-width": "2",
  d: "m18.153 40.617-.057.042c-.427.317-.94.38-1.352.321s-.885-.261-1.205-.682l-.003-.004L4.209 25.59l-.001-.001C2.165 22.946 1 19.759 1 16.382 1 7.854 8.239 1 17 1s16 6.854 16 15.382c0 3.376-1.165 6.564-3.208 9.207zm0 0 .051-.05.167-.167.048-.047.04-.052 11.332-14.71z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#000",
  "fill-rule": "evenodd",
  d: "M17.534 8c-1.375.003-2.76.261-4.148.762q-.02.005-.04.011l-.032.011h-.006c-.279.103-.563.226-.809.427-.256.21-.465.544-.465.943v9.85c0 .783.66 1.404 1.435 1.404h.548l-1.9 1.973c-.266.272-.042.619.3.619h10.175c.411.003.527-.405.276-.654-.65-.652-1.296-1.293-1.944-1.938h.61c.774 0 1.434-.62 1.434-1.404v-9.85c0-.4-.214-.73-.47-.937-.257-.208-.553-.334-.837-.444A11.3 11.3 0 0 0 17.534 8m-4.79 3.746h4.347v3.643h-4.348zm5.056 0h4.46v3.643H17.8zm-3.146 5.712c.583 0 1.064.493 1.064 1.091s-.48 1.091-1.064 1.091c-.583 0-1.063-.493-1.063-1.09 0-.6.48-1.092 1.063-1.092m5.677.006c.584 0 1.064.493 1.064 1.09 0 .599-.48 1.092-1.064 1.092-.582 0-1.063-.493-1.063-1.091s.48-1.091 1.063-1.091m-5.317 3.944h4.891l.526.523h-5.92zm-1.202 1.25h7.35l.615.614H13.22z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }